// extracted by mini-css-extract-plugin
export default {"navigation_btn":"NavigationBtn_navigation_btn__zKNbt","left":"NavigationBtn_left__r1LLN"};